import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import { getMessages, approveMessage, deleteMessage } from '../services/adminApi';

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [pagination, setPagination] = useState({});
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const fetchMessages = async (page = 1) => {
    setLoading(true);
    try {
      const data = await getMessages(page, 20, filter);
      setMessages(data.messages);
      setPagination(data.pagination);
    } catch (err) {
      console.error('Failed to fetch messages:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [filter]);

  const handleApprove = async (id, approved) => {
    try {
      await approveMessage(id, approved);
      setMessages(messages.map(m =>
        m.id === id ? { ...m, approved } : m
      ));
    } catch (err) {
      alert('Aktion fehlgeschlagen');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Nachricht wirklich löschen?')) return;

    try {
      await deleteMessage(id);
      setMessages(messages.filter(m => m.id !== id));
    } catch (err) {
      alert('Löschen fehlgeschlagen');
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white">Messages</h1>
          <div className="flex gap-2">
            {['all', 'approved', 'pending'].map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-colors ${
                  filter === f
                    ? 'bg-blue-500 text-white'
                    : 'bg-white/5 text-gray-400 hover:bg-white/10'
                }`}
              >
                {f === 'all' ? 'Alle' : f === 'approved' ? 'Genehmigt' : 'Ausstehend'}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden">
          {loading ? (
            <div className="p-8 text-center text-gray-400">Laden...</div>
          ) : messages.length === 0 ? (
            <div className="p-8 text-center text-gray-400">Keine Nachrichten gefunden</div>
          ) : (
            <div className="divide-y divide-white/5">
              {messages.map((message) => (
                <div key={message.id} className="p-4 hover:bg-white/5 transition-colors">
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="font-mono text-xs text-gray-500">{message.id}</span>
                        <span className={`px-2 py-0.5 rounded text-xs ${
                          message.approved
                            ? 'bg-green-500/20 text-green-300'
                            : 'bg-yellow-500/20 text-yellow-300'
                        }`}>
                          {message.approved ? 'Genehmigt' : 'Ausstehend'}
                        </span>
                        <span className="text-xs text-gray-500">
                          {new Date(message.timestamp).toLocaleString('de-DE')}
                        </span>
                      </div>
                      <p className="text-gray-300 break-words">{message.message}</p>
                    </div>

                    <div className="flex gap-2 shrink-0">
                      {message.approved ? (
                        <button
                          onClick={() => handleApprove(message.id, false)}
                          className="px-3 py-1.5 text-xs bg-yellow-500/20 text-yellow-300 rounded-lg hover:bg-yellow-500/30 transition-colors"
                        >
                          Zurückziehen
                        </button>
                      ) : (
                        <button
                          onClick={() => handleApprove(message.id, true)}
                          className="px-3 py-1.5 text-xs bg-green-500/20 text-green-300 rounded-lg hover:bg-green-500/30 transition-colors"
                        >
                          Genehmigen
                        </button>
                      )}
                      <button
                        onClick={() => handleDelete(message.id)}
                        className="px-3 py-1.5 text-xs bg-red-500/20 text-red-300 rounded-lg hover:bg-red-500/30 transition-colors"
                      >
                        Löschen
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          {pagination.pages > 1 && (
            <div className="flex items-center justify-center gap-2 p-4 border-t border-white/5">
              {Array.from({ length: pagination.pages }, (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => fetchMessages(i + 1)}
                  className={`px-3 py-1 rounded ${
                    pagination.page === i + 1
                      ? 'bg-blue-500 text-white'
                      : 'bg-white/5 text-gray-400 hover:bg-white/10'
                  }`}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
